import type { SpinResponse } from "@slot/client-engine";
import { baseFixtureBonusHuntTease } from "./base_fixture_bonus_hunt_tease";
import { baseFixtureReelAnticipation } from "../base/base_fixture_reel_anticipation";
import { fsFixtureFreeSpins } from "../feature/fs_fixture_free_spins";

/**
 * SPIN-MODE base pools — served instead of the normal base playlist while a persistent
 * mode is active (`SpinRequest.requestedFeatureModeIdentifier` routes here via the
 * ScriptedRoundProvider's keyed catalog). Simulated server authority: the mode changes
 * WHAT the server deals, the client just presents it.
 */

/** BONUS HUNT — tease-heavy with a high natural trigger rate (1 in 3 spins triggers). */
export function createBonusHuntFixtures(): SpinResponse[] {
  return [
    baseFixtureBonusHuntTease(),
    baseFixtureReelAnticipation(),
    // The natural trigger — a full triggered FS session (reels-shaped).
    fsFixtureFreeSpins(),
  ];
}
